import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getMarketAppRequest = {};
var _getMarketAppResponse = { marketApp: '_marketApp' };
var _marketApp = {
    firstPublishDate: 'google.protobuf.Timestamp',
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _queryMarketAppRequest = {};
var _queryMarketAppResponse = { marketApps: '_marketApp' };
var _updateMarketAppRequest = {
    mask: 'google.protobuf.FieldMask',
    marketApp: '_marketApp',
};
var _updateMarketAppResponse = { marketApp: '_marketApp' };
function resolveWixDevcenterMarketappsV1MarketAppsServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/market-apps',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/market-apps',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/market-apps',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/market-apps',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/market-apps',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/market-apps',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/market-apps',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/market-apps',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/market-apps',
                destPath: '',
            },
            {
                srcPath: '/market-apps',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Get a MarketApp by id */
export function getMarketApp(payload) {
    var _a = serializer(_getMarketAppRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMarketAppResponse, {
        _marketApp: _marketApp,
    }).fromJSON;
    function __getMarketApp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.market_apps.v1.market_app',
            method: 'GET',
            methodFqn: 'wix.devcenter.marketapps.v1.MarketAppsService.GetMarketApp',
            url: resolveWixDevcenterMarketappsV1MarketAppsServiceUrl({
                protoPath: '/v1/marketApps/{appId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getMarketApp.fromReq = fromReq;
    __getMarketApp.__isAmbassador = true;
    return __getMarketApp;
}
/**
 * Update a MarketApp, supports partial update
 * Pass the latest `revision` for a successful update
 */
export function updateMarketApp(payload) {
    var _a = serializer(_updateMarketAppRequest, { _marketApp: _marketApp }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateMarketAppResponse, {
        _marketApp: _marketApp,
    }).fromJSON;
    function __updateMarketApp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.market_apps.v1.market_app',
            method: 'PATCH',
            methodFqn: 'wix.devcenter.marketapps.v1.MarketAppsService.UpdateMarketApp',
            url: resolveWixDevcenterMarketappsV1MarketAppsServiceUrl({
                protoPath: '/v1/marketApps/{marketApp.appId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateMarketApp.fromReq = fromReq;
    __updateMarketApp.__isAmbassador = true;
    return __updateMarketApp;
}
/** Query MarketApps using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) */
export function queryMarketApp(payload) {
    var _a = serializer(_queryMarketAppRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryMarketAppResponse, {
        _marketApp: _marketApp,
    }).fromJSON;
    function __queryMarketApp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.market_apps.v1.market_app',
            method: 'POST',
            methodFqn: 'wix.devcenter.marketapps.v1.MarketAppsService.QueryMarketApp',
            url: resolveWixDevcenterMarketappsV1MarketAppsServiceUrl({
                protoPath: '/v1/marketApps/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryMarketApp.fromReq = fromReq;
    __queryMarketApp.__isAmbassador = true;
    return __queryMarketApp;
}
//# sourceMappingURL=http.impl.js.map